// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__x1Kfe","fileBtn":"File_fileBtn__8GpHB","closeBtn":"File_closeBtn__2wGL6","fileSelected":"File_fileSelected__3Nj9t","disabled":"File_disabled__18pVA"};